import * as React from 'react'
import notice from '../notice'
import loginSVG from './loading.svg'
import './style.scss'

const loadingLayer = {
  show (duration?: number) {
    return notice.noticeMessage({
      content: <img src={loginSVG} />,
      duration: duration || 10000,
      className: 'notice-loading',
      mask: true,
    })
  },
  hide () {
    notice.destory()
  },
}

if (window.MX) {
  window.MX.loadingLayer = loadingLayer
}

export default loadingLayer
